// extracted by mini-css-extract-plugin
export default {"timeSelect":"GlobalTimeRangeFilter_timeSelect__kSjF7"};